export const styles = {
  container: {
    overflowX: "auto",
  },
};
